<template lang="pug">
  div
    // NOT PTS BUTTON
    Button3d.btn-xlarge.pd(
      v-if="displayPts.length < 1 && !recordingKind && !recording",
      :block="true",
      size="large",
      :color="displayInfo.color",
      @click.prevent="submit",
      :id="id")
        .pts-wrapper
          p.kind-number {{ displayInfo.number }}
          p.kind-name {{ displayInfo.kindName }}
          img.pts-icon.re-mobile(:src="displayInfo.icon", :class="{[displayInfo.iconClass]: true}")

    // HAS PTS BUTTON
    Button3d.btn-xlarge.pd(
      v-if="displayPts.length >= 1 && !recordingKind && !recording",
      :active="true",
      @click.prevent="submit", color="default", :block="true",
      size="large",
      :id="id")
        | {{ displayInfo.kindName }} {{displayInfo.text}} ({{ displayInfo.number }})
        //h4.is-size-5 Pontos de hoje
        h4.is-size-5 {{ getDayPts(displayPts.slice(-5))}}


    Button3d.btn-xlarge.pd(
    v-if="!recordingKind && recording",
    color="default", :block="true",
    size="large",
    )
      .pts-wrapper
        p.kind-number {{ displayInfo.number }}
        p.kind-name {{ displayInfo.kindName }}
        img.pts-icon.re-mobile(:src="displayInfo.icon", :class="{[displayInfo.iconClass]: true}")

    // RECONDING AUDIO BUTTON
    Button3d.btn-xlarge.pd(
      v-if="recordingKind",
      :color="displayInfo.color",
      size="large",
      :block="true")
          slot
            p Diga o seu nome...
            p {{seconds}}

    vue-recaptcha(
    v-if="this.showRecaptcha",
    ref="invisibleRecaptcha",
    :sitekey="displayInfo.recaptchaKey",
    size="invisible",
    @verify="onCaptchaVerified",
    @expired="onCaptchaExpired")


</template>

<script>
  import moment from 'moment'
  import { groupBy, omit, mapValues } from 'lodash'
  import { mapGetters } from 'vuex'
  import VueRecaptcha from 'vue-recaptcha';
  import { RECAPTCH_PUBLIC } from './state'

  export default {
    props: {
      displayPts: {type: Array, required: true},
      kind: {type: String, required: true},
      recording: {type: Boolean, required: true},
      showRecaptcha: {type: Boolean, required: true},
      recordingKind: {type: Boolean, required: true},
      seconds: {type: Number, required: true},
      id: {type: String}
    },
    components: {
      VueRecaptcha,
    },
    computed: {
      ...mapGetters(['visual']),
      displayInfo() {
        const i = {
          start: [this.visual.webButtonEntrada, 'Entrada', 1, require('../../../static/images/entrada.svg'), 'entrada', 'efetuada'],
          stPause: [this.visual.webButtonPausa, 'Pausa', 2, require('../../../static/images/pausa.svg'), 'pausa', 'efetuada'],
          endPause: [this.visual.webButtonRetorno, 'Retorno', 3, require('../../../static/images/retorno.svg'), 'retorno', 'efetuado'],
          end: [this.visual.webButtonSaida, 'Saída', 4, require('../../../static/images/saida.svg'), 'saida', 'efetuada']
        }
        return {
          color: i[this.kind][0],
          kindName: i[this.kind][1],
          number: i[this.kind][2],
          icon: i[this.kind][3],
          iconClass: i[this.kind][4],
          text: i[this.kind][5],
          recaptchaKey: RECAPTCH_PUBLIC
        }
      }
    },
    methods: {
      onCaptchaVerified: function (recaptchaToken) {
        this.punchTimelog(recaptchaToken)
      },
      onCaptchaExpired: function () {
        this.$refs.invisibleRecaptcha.reset();
      },
      submit () {
        if (this.showRecaptcha) {
          try {
            this.$refs.invisibleRecaptcha.execute()
          } catch (e) {
            console.warn('recaptcha not found on execute, weird')
            setTimeout(function () {
              this.$refs.invisibleRecaptcha.execute()
            }, 50)
          }
        } else {
          this.punchTimelog()
        }
      },
      punchTimelog(token) {
        if (token) {
          this.$refs.invisibleRecaptcha.reset()
        }
        this.$emit('punchTimelog', this.kind, token)
      },
      getDayPts(ptsData) {
        let ptsList = ''
        ptsData.forEach((item) => {
          item.date = moment(item.time).format('DD/MM/YY')
        });

        var grouped = mapValues(groupBy(ptsData, 'date'),
          clist => clist.map(pts => omit(pts, 'date')));

        for (let key of Object.keys(grouped)) {
          ptsList += key + ' - '
          for (let pt of grouped[key]) {
            ptsList += `${moment(pt.time).format('HH:mm')}${ pt.fake ? '*' : ''} `
           }
        }
        return ptsList
      }
    }
  }
</script>

<style scoped>

.btn-xlarge {
  width: 370px;
  height: 185px;
  padding: 0px;
  font-size: 25px !important;
  line-height: normal;
  margin: 0px;
  grid-template-rows: 2fr 2fr;
}


@media screen and (min-width: 1024px) and (max-height: 600px) {
  .btn-xlarge {
    height: 130px;
  }
}

@media screen and (max-width: 1000px) {
  .btn-xlarge {
    height: 130px;
  }
}

@media screen and (max-width: 420px) {
  .btn-xlarge {
    width: 350px;
  }
}
img.re-mobile {
  float: right;
  max-width: 100px;
}
.pts-wrapper{
  position: relative;
  height: 100%;
  flex-direction: column;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}
.pts-n{
  position: absolute;
  left: 30px;
  top: 0px;
  font-size: 60px;
}
.pts-text{
  position: absolute;
  bottom: 10px;
  left: 30px;
  font-size: 35px;
}
.pts-icon{
  position: absolute;
  bottom: 10px;
  right: 30px;
}

.entrada, .saida {
  max-height: 80px;
}
.pausa {
  max-height: 110px;
}
.retorno {
  max-height: 75px;
}
.kind-name, .kind-number {
  text-align: left;
}
.kind-name {
  grid-row-start: 2;
  grid-column-start: 1;
}

@media (min-width: 1000px) {
  .kind-number, .kind-name {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 8vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}
@media (min-width: 600px) and (max-width: 1000px) {
  .kind-number, .kind-name {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 6vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}
@media (max-width: 600px) {
  .kind-number, .kind-name {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 6vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}
</style>
